import { Injectable } from '@angular/core';
import { AbstractFeatureService } from '@y42/feature';
import { Y42RouterService } from '@y42/feature/routing';
import { GitQuery } from '@y42/git';
import { Y42FeatureType } from '@y42/json-schema';
import { ToastService } from '@y42/toast';
import { CatalogAclService } from './catalog-acl.service';
import { CatalogGitService } from './catalog-git.service';
import { CatalogState, CatalogStoreModel } from './catalog.model';
import { CatalogQuery } from './catalog.query';
import { CatalogStore } from './catalog.store';

@Injectable({ providedIn: 'root' })
export class CatalogService extends AbstractFeatureService<CatalogState> {
  constructor(
    protected readonly store: CatalogStore,
    protected readonly query: CatalogQuery,
    protected readonly git: CatalogGitService,
    protected readonly acl: CatalogAclService,
    protected readonly gitQuery: GitQuery,
    protected readonly routerService: Y42RouterService,
    protected readonly toast: ToastService,
  ) {
    super({
      featureType: Y42FeatureType.Catalog,
      store,
      query,
      userData: null,
      gitQuery,
      git,
      toast,
      acl,
      childStores: [],
    });
  }

  create(item: unknown): Promise<void> {
    throw new Error('Method not implemented.');
  }
  update(item: Partial<CatalogStoreModel>, $path?: string): Promise<void> {
    throw new Error('Method not implemented.');
  }
  delete($path?: string): Promise<void> {
    throw new Error('Method not implemented.');
  }
}
